<template>
  <div class="keep-scrolling">
    <h1>Finance</h1>
    <iframe  v-if="!isLoaded" :src="url"></iframe>
    <div class="ph-item" v-if="isLoaded">
      <div class="ph-col-12">
        <div class="ph-row">
          <div class="ph-col-6 big"></div>
          <div class="ph-col-4 empty big"></div>
          <div class="ph-col-2 big"></div>
          <div class="ph-col-4"></div>
          <div class="ph-col-8 empty"></div>
          <div class="ph-col-6"></div>
          <div class="ph-col-6 empty"></div>
          <div class="ph-col-4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import ClockifyReportService from "@/services/clockifyReportService";

export default Vue.extend({
  Name: "Finance",

  data() {
    return {
      url: "",
      isLoaded: false
    };
  },

  async created() {
    this.isLoaded = true;
    const jwt = window.localStorage.getItem("jwt");
    if (jwt) {
      const crService = new ClockifyReportService(jwt);
      const response = await crService.getReport();
      console.log(response.data);
      console.log(response);

      if (response !== undefined && response !== null) {
        if (response.data.reports[0] !== undefined && response.data.reports[0] !== null) {
          this.url = response.data.reports[0].url;
        }
      }
    }

    // Find better sulution
    document.getElementById("Content").style.backgroundColor = "rgb(242,246,248)";
    document.getElementById("app").style.backgroundColor = "rgb(242,246,248)";
    setInterval(()=>{
      this.isLoaded = false;
    },3000)
  },

  destroyed() {
    // Find better sulution
    document.getElementById("Content").style.backgroundColor = "rgb(255,255,255)";
    document.getElementById("app").style.backgroundColor = "rgb(255,255,255)";
  }
});
</script>

<style scoped lang="scss">
h1 {
  border-bottom: 2px solid var(--tq-blue);
  padding-bottom: 8px;
}

iframe {
  height: 91vh;
  width: 100%;
  border: none;
  flex: 1 0 auto;
}

.keep-scrolling {
  overflow-y: scroll; /* Add the ability to scroll y axis*/
}

/* Hide scrollbar for Chrome, Safari and Opera */
.keep-scrolling::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.keep-scrolling {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
